/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ConfigurationLinkRel, ConfigurationResource, ConfigurationService } from '@administration-client/configuration-shared';
import { ApiListResourceService, ListResourceServiceConfig, ResourceLinkRel, StateService } from '@common/tech-shared';
import { Resource } from '@ngxp/rest';
import { SettingListLinkRel } from './settings.linkrel';
import { SettingItemResource, SettingListResource } from './settings.model';
import { SETTINGS_FEATURE_KEY, SETTINGS_LIST_PATH } from './settings.state';

export class SettingListResourceService extends ApiListResourceService<
  Resource,
  SettingListResource,
  SettingItemResource<unknown>
> {}

export function createSettingListResourceService(configurationService: ConfigurationService, stateService: StateService) {
  return new ApiListResourceService(buildConfig(configurationService), stateService);
}
function buildConfig(configurationService: ConfigurationService): ListResourceServiceConfig<ConfigurationResource> {
  return {
    stateInfo: { name: SETTINGS_FEATURE_KEY, path: SETTINGS_LIST_PATH },
    baseResource: configurationService.selectResource(),
    listResourceListLinkRel: SettingListLinkRel.LIST,
    getLinkRel: ConfigurationLinkRel.SETTING,
    create: { linkRel: ResourceLinkRel.SELF },
  };
}
